<template>
  <div id="data-portal-des">
    <!-- <h5> Last update: {{ lastUpdate }} </h5> -->
    <el-descriptions 
      :title="'Release version: ' + release" 
      :column="3" 
      direction="vertical"
      :colon="false" 
      labelClassName="portal-label" 
      contentClassName="portal-content"
    >
      <el-descriptions-item v-for="(item, index) in portalData" :label="item.title" :key="index">
        <i class="iconfont mr-2" :class="[iconList[index]]"></i>
        <span v-if="typeof item.data === 'number'">
          {{ item.data | numberToCurrency }}
          <span v-if="item.title === 'Genomes'" style="color: rgba(0,0,0,0.45);">(🌱230 🐵40)</span>
          <span v-if="item.title === 'Species'" style="color: rgba(0,0,0,0.45);">(🌱121 🐵32)</span>
        </span>
        <span v-else>
          {{ item.data }}
        </span>
      </el-descriptions-item>

    </el-descriptions>

<div class="PLANTpie" style="overflow-x: auto; white-space: nowrap; width: 100%;">
  <el-row style="display: flex; flex-wrap: nowrap; margin-bottom: 10px;">
    <el-col :span="12" style="flex: 0 0 auto;">
      <chart-view :chartOption="t2tTypepie"></chart-view>
    </el-col>
    <el-col :span="12" style="flex: 0 0 auto;">
      <chart-view :chartOption="PloidyTypepie"></chart-view>
    </el-col>
    <el-col :span="12" style="flex: 0 0 auto;">
      <chart-view :chartOption="CountryTypepie"></chart-view>
    </el-col>
    <el-col :span="15" style="flex: 0 0 auto;">
      <chart-view :chartOption="GenomeSourcepie"></chart-view>
    </el-col>
    <el-col :span="20" style="flex: 0 0 auto;">
      <chart-view :chartOption="assem_sourcepie"></chart-view>
    </el-col>
    <el-col :span="20" style="flex: 0 0 auto;">
      <chart-view :chartOption="Journalpie"></chart-view>
    </el-col>


  </el-row>
</div>

  </div>
  
</template>

<script>
import { getDataPortal } from '@/api/api';
import t2tTypePie from "@/components/echarts/options/pie/t2tTypePie";
import PloidyTypePie from "@/components/echarts/options/pie/PloidyTypePie";
import CountryTypePie from "@/components/echarts/options/pie/CountryTypePie";
import GenomeSourcePie from "@/components/echarts/options/pie/GenomeSourcePie";
import assem_sourcePie from "@/components/echarts/options/pie/assem_sourcePie";
import JournalPie from "@/components/echarts/options/pie/JournalPie";
import ChartView from "@/components/echarts/main.vue";

export default {
  components: { ChartView },
  data() {
    return {
      release: '1.0',  // 默认版本信息
      lastUpdate: 'N/A',  // 最新更新时间
      portalData: [],  // API 返回的数据
      T2Ttype_data: [],  // T2T 数据
      PloidyName_data: [],  // PloidyName 数据
      Country_data: [],  // Country 数据
      GenomeSource_data: [],  // GenomeSource 数据
      assem_source_data: [],  // assem_source 数据
      Journal_data: [],  // Journal 数据
      iconList: [
        "icon-ziyuan", "icon-zhiwu", "icon-xiangmu", 
        "icon-dna-full", "icon-RNA", "icon-DNA"
      ]
    };
  },
  created() {
    this.getHbDataPortal();
  },
  computed: {
    t2tTypepie() {
      return this.T2Ttype_data ? t2tTypePie(this.T2Ttype_data) : {};  // 确保数据存在才调用 t2tTypePie
    },
    PloidyTypepie() {
      return this.PloidyName_data ? PloidyTypePie(this.PloidyName_data) : {};  // 确保数据存在才调用 t2tTypePie
    },
    CountryTypepie() {
      return this.Country_data ? CountryTypePie(this.Country_data) : {};  // 确保数据存在才调用 t2tTypePie
    },
    GenomeSourcepie() {
      return this.GenomeSource_data ? GenomeSourcePie(this.GenomeSource_data) : {};  // 确保数据存在才调用 t2tTypePie
    },
    assem_sourcepie() {
      return this.assem_source_data ? assem_sourcePie(this.assem_source_data) : {};  // 确保数据存在才调用 t2tTypePie
    },
    Journalpie() {
      return this.Journal_data ? JournalPie(this.Journal_data) : {};  // 确保数据存在才调用 t2tTypePie
    }

  },
  methods: {
    getHbDataPortal() { 
      getDataPortal().then(response => {
        // 获取后端返回的 data 数据
        const data = response.data;

        this.release = data.release;  // 更新 release 版本
        this.T2Ttype_data = data.T2Ttype_data;  // 存储 T2Ttype_data
        this.PloidyName_data = data.PloidyName_data;  // 存储 PloidyName_data
        this.Country_data = data.Country_data;  // 存储 Country_data
        this.GenomeSource_data = data.GenomeSource_data;  // 存储 GenomeSource_data
        this.assem_source_data = data.assem_source_data;  // 存储 assem_source_data
        this.Journal_data = data.Journal_data;  // 存储 Journal_data
        // console.log(data)

        // 解析返回的 portal 数据并更新 lastUpdate
        let rawData = data.portal.reduce((acc, item) => {
          acc[item.title] = item.data;
          return acc;
        }, {});

        this.lastUpdate = rawData["LastUpdate"] || "N/A";  // 获取最后更新时间

        // 格式化 lastUpdate
        if (this.lastUpdate !== "N/A") {
          const date = new Date(this.lastUpdate);
          const year = date.getFullYear();
          const month = date.getMonth() + 1; // getMonth() returns 0-11, so add 1
          const day = date.getDate();

          this.lastUpdate = `${year}-${month}-${day}`; // Format as '2024-8-21'
        }

        // 格式化并组织数据到 portalData
        this.portalData = [
          { title: 'Genomes', data: Number(rawData["Genome"]) },
          { title: 'Species', data: Number(rawData["Species"]) },
          { title: 'Projects', data: Number(rawData["Project"]) },
          { title: 'Genes', data: Number(rawData["Gene"]) },
          { title: 'Transcripts', data: Number(rawData["Transcript"]) },
          { title: 'T2T/all chr.', data: `${rawData["T2TCount"].toLocaleString()}/${rawData["allCount"].toLocaleString()}` }
        ];
      }).catch(error => {
        console.error("Error fetching data:", error);
      });
    }
  }
}
</script>

<style lang="scss">
  #data-portal-des {
    .el-descriptions__body {
      background: transparent;
    }

    .iconfont {
      color: #28A745;
      font-size: 1.5rem;
    }
  }
  .portal-label{
    font-size: 1.35rem;
  }
  .portal-content {
    font-size: 1.15rem;
  }

/* 美化滚动条，减小其突出度 */
.PLANTpie {
  -ms-overflow-style: auto;  /* 保留滚动条（适用于 IE 和 Edge） */
  scrollbar-width: thin;      /* 滚动条变细（适用于 Firefox） */
  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0); /* 滚动条颜色为透明黑色 */
}

/* 针对 Webkit 浏览器（如 Chrome 和 Safari） */
.PLANTpie::-webkit-scrollbar {
  height: 6px;  /* 设置滚动条的高度 */
}

.PLANTpie::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2); /* 设置滑块颜色为透明黑色 */
  border-radius: 3px; /* 滚动条滑块圆角 */
}

.PLANTpie::-webkit-scrollbar-track {
  background: transparent; /* 设置滚动条轨道为透明 */
}
</style>